import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { IProcessListPayload } from '../../processes/models/processes.models';
import { IDashboardFilters } from '../models/panel.models';
import { buildCurlPostJson } from '../utils/build-curl.util';
import { PanelService } from './panel.service';

@Injectable({
	providedIn: 'root',
})
export class PanelCurlService {
	private panelService = inject(PanelService);

	public buildTotalProcessDateCurl(formattedFilters: Record<string, unknown>): string {
		const body = this.panelService.prepareDashboardPostBody(formattedFilters as IDashboardFilters);
		return buildCurlPostJson(environment.apiUrl, '/dashboard/total-process-date', body as object);
	}

	public buildGraphProcessCurl(formattedFilters: Record<string, unknown>): string {
		const body = this.panelService.prepareDashboardPostBody(formattedFilters as IDashboardFilters);
		return buildCurlPostJson(environment.apiUrl, '/dashboard/graph-process', body as object);
	}

	public buildTopNationalityProcessesCurl(formattedFilters: Record<string, unknown>): string {
		const body = this.panelService.prepareDashboardPostBody(formattedFilters as IDashboardFilters);
		return buildCurlPostJson(environment.apiUrl, '/dashboard/top-nationality-processes', body as object);
	}

	public buildRejectedByErrorCodeCurl(formattedFilters: Record<string, unknown>): string {
		const body = this.panelService.prepareDashboardPostBody(formattedFilters as IDashboardFilters);
		return buildCurlPostJson(environment.apiUrl, '/dashboard/rejected-by-error-code', body as object);
	}

	public buildPanelProcessesCurl(payload: IProcessListPayload): string {
		return buildCurlPostJson(environment.apiUrl, '/processes', payload as object);
	}

	/** @deprecated Usar buildPanelProcessesCurl — misma ruta /processes. */
	public buildPendingValidationProcessesCurl(payload: IProcessListPayload): string {
		return this.buildPanelProcessesCurl(payload);
	}

	/** @deprecated Usar buildPanelProcessesCurl — misma ruta /processes. */
	public buildInProgressProcessesCurl(payload: IProcessListPayload): string {
		return this.buildPanelProcessesCurl(payload);
	}
}
